import { render, staticRenderFns } from "./RepairCauseDetail.vue?vue&type=template&id=63491575&scoped=true"
import script from "./RepairCauseDetail.vue?vue&type=script&lang=js"
export * from "./RepairCauseDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63491575",
  null
  
)

export default component.exports